import { z } from "zod";

export enum FlaggableType {
  Campaign = "campaign",
  ChannelMessage = "channel_message",
  Community = "community",
  IcebreakerResponse = "icebreaker_response",
  Intention = "intention",
  NoteOfSupport = "note_of_support",
  Post = "post",
  PromptResponse = "prompt_response",
  User = "user",
}

export const flaggableTypeEnum = z.enum(FlaggableType);
